import React, { Component } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Card from "@material-ui/core/Card"
import CardMedia from "@material-ui/core/CardMedia"
import Image from "../../assets/images/login_bg.jpg"
import classNames from "classnames"
import { isEmpty, flatten } from "lodash"
import { hiddenLoginModal } from "../../actions/authentication"

class CrewRateSlate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      checked: false,
      equipmentAnchor: null,
      vehicleAnchor: null,
      positionsAnchor: null,
      videoModalOpen: false,
      menuAnchorEl: null,
    }
  }

  handleBook = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.onOpenBookingDialog(this.props.crew)
      })
      .catch(err => console.log({ err }))
  }

  handleRating = num => {
    hiddenLoginModal()
      .then(res => {
        this.props.ratingChanged(num)
      })
      .catch(err => console.log({ err }))
  }

  handleOpenMenu = e => {
    this.setState({ menuAnchorEl: e.currentTarget })
  }
  handleCloseMenu = () => {
    this.setState({ menuAnchorEl: null })
  }
  handleMenuItemClick = (action, note) => {
    this.handleCloseMenu()
    this.props.onRemoveFromCompany(this.props.crew)
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }

  handleChecked = event => {
    this.setState({ checked: event.target.checked })
  }
  handlePopoverOpen = (name, event) => {
    this.setState({ [`${name}Anchor`]: event.target })
  }

  handlePopoverClose = name => {
    this.setState({ [`${name}Anchor`]: null })
  }
  generate(element) {
    return [0, 1, 2].map(value =>
      React.cloneElement(element, {
        key: value,
      })
    )
  }
  beforeOpenModal = e => {
    const crew = this.props.crew
    let url = `/${crew.id}`
    if (e.target.id === "card-media") {
      if (this.props.currentUser.id) {
        this.props.onOpenProfile()
      } else {
        const { locations, roles } = crew
        // first_name && first_name.length > 0 && (url += `/${first_name}`)
        // last_name && last_name.length > 0 && (url += `_${last_name}`)
        this.props.isPositionSearch && this.props.isPositionSearch.name
          ? (url += `/${this.props.isPositionSearch.name.replace(/\W/g, "_")}`)
          : roles &&
            roles.length > 0 &&
            (url += `/${roles[
              Math.floor(Math.random() * roles.length)
            ].name.replace(/\W/g, "_")}`)
        locations &&
          locations.length > 0 &&
          (url += `/${locations[
            Math.floor(Math.random() * locations.length)
          ].city.replace(/\W/g, "_")}`)
        window.location.href = window.location.origin + url.toLowerCase()
      }
    }
  }

  hasNotClaimed = () => {
    return (
      flatten([
        this.props.crew.roles,
        this.props.crew.locations,
        this.props.crew.equipment,
        this.props.crew.vehicles,
      ]).find(c => c.creator_id === this.props.crew.id) === undefined
    )
  }
  render() {
    let companyRating = undefined
    if (this.props.accessLevel === 1) {
      companyRating = this.props.crew.ratings
        .sort((a, b) => b.score - a.score)
        .find(r => r.company_id === this.props.activeCompany)
    }
    const myRating = this.props.crew.ratings
      .sort((a, b) => b.score - a.score)
      .find(
        r => r.creator_id === this.props.currentUser.id && r.company_id === 0
      )
    let selectedRating = 0
    if (companyRating) {
      selectedRating = companyRating.score
    } else if (myRating && this.props.activeCompany === null) {
      selectedRating = myRating.score
    }
    const canDelete =
      this.props.crew.companies.length === 1 &&
      this.props.crew.companies[0].id === this.props.activeCompany &&
      this.hasNotClaimed()
    return (
      <Card
        className={[this.props.classes.card, this.props.className]}
        style={{
          border: this.props.crew.membershipValid ? "2px solid #0CADFF" : null,
        }}
      >
        {this.props.topArea && this.props.topArea()}
        <CardMedia
          id="card-media"
          className={classNames(
            this.props.classes.trigger,
            this.props.classes.media,
            {
              [this.props.classes.imageOverlay]:
                selectedRating === 6 || selectedRating === -1,
              [this.props.classes.imageOverlayPreferred]: selectedRating === 6,
              [this.props.classes.imageOverlayDoNotUse]: selectedRating === -1,
            }
          )}
          image={
            !isEmpty(this.props.crew.profile_image)
              ? `https://res.cloudinary.com/${
                  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                }/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                  this.props.crew.profile_image.version
                }/${this.props.crew.profile_image.public_id}.${
                  this.props.crew.profile_image.format
                }`
              : Image
          }
        />
      </Card>
    )
  }
}

export default withStyles(styles, { withTheme: true })(CrewRateSlate)
